<template>
  <div class="result">
    <div class="alert alert-danger" role="alert" v-if="errorMsg">
      {{ errorMsg }}
    </div>
    <div class="row clearfix" v-if="widgets.length">
      <div
        class="col-sm-12"
        v-for="widget in widgets"
        :key="widget.widgetObject.selector"
      >
        <div
          class="card"
          style="text-align: center"
          @mouseenter="onMouseEnter()"
          @mouseleave="onMouseLeave(widget.widgetObject.selector)"
        >
          <div v-bind:id="widget.widgetObject.selector" class="card-body"></div>
        </div>
        <Feedback
          v-if="
            widget.widgetObject.selector ===
            'apnic-experimental_apnic-irr-explorer'
          "
          widgetName="apnic-irr-explorer"
        ></Feedback>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Feedback from '../Feedback.vue';

export default {
  components: { Feedback },
  data() {
    return {
      timer: 0,
    };
  },
  props: ['tabId'],
  methods: {
    load(widgets) {
      // wait for the dom render first
      // jquery need the dom to be ready
      this.$nextTick(() => {
        widgets.forEach((widget) => {
          const { params, selector, styling, widgetName } = widget.widgetObject;
          window.ripestat.init(widgetName, params, selector, styling);
        });
      });
    },
    onMouseEnter() {
      this.timer = new Date();
    },
    onMouseLeave(id) {
      const diff = new Date() - this.timer;
      if (diff > 2000) {
        window.dataLayer.push({
          event: 'widgetHover',
          widgetName: id.split('_')[1],
        });
      }
    },
  },
  computed: {
    ...mapGetters(['currentWidgets', 'errorMsg']),
    widgets() {
      return this.currentWidgets(this.tabId);
    },
  },
  mounted() {
    this.load(this.widgets);
  },
};
</script>

<style scoped lang="scss">
.result {
  position: relative;
}

.alert {
  margin-top: 2rem;
}

@include widget-card;

.card-body {
  width: 100% !important;
}
</style>
